
        import 'CancelSubscription.b707639.css-module'
        export default {"details":"details_CancelSubscription_b707639","wideField":"wideField_CancelSubscription_b707639","container":"container_CancelSubscription_b707639","table":"table_CancelSubscription_b707639"}
    